module.exports = __webpack_public_path__ + "static/media/ic_康复计划_pr.67b1db08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_康复计划_pr.svg
// module id = 192
// module chunks = 0